/**
 * Retrieves and parses a value from sessionStorage by its key.
 *
 * @function getSessionItem
 * @param {string} key - The sessionStorage key to retrieve.
 * @returns {any|null} The parsed value stored under the given key, or null if the key
 * does not exist, the value is invalid JSON, or an error occurs during parsing.
 */
export const getSessionItem = (key) => {
  try {
    const value = sessionStorage.getItem(key);
    return value ? JSON.parse(value) : null;
  } catch {
    sessionStorage.removeItem(key);
    return null;
  }
};

/**
 * Stores a value in sessionStorage after serializing it to JSON.
 *
 * @function setSessionItem
 * @param {string} key - The sessionStorage key under which the value will be stored.
 * @param {any} value - The value to store. It will be serialized using JSON.stringify.
 * @returns {void}
 */
export const setSessionItem = (key, value) => {
  sessionStorage.setItem(key, JSON.stringify(value));
};

/**
 * Removes an item from sessionStorage by its key.
 *
 * @function removeSessionItem
 * @param {string} key - The sessionStorage key to remove.
 * @returns {void}
 */
export const removeSessionItem = (key) => {
  sessionStorage.removeItem(key);
};
